import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";
import { TreatmentsContainerDto } from "@apiModels/TreatmentsContainerDto.csharp";
import { useEffect, useState } from "react";
import { haveCommonElements } from "../Helpers";
import {
  getServiceContainersFromTreatments,
  isTreatmentContainer,
} from "../Helpers/treatmentsHelpers";

export const useFilteredLocationsForTreatment = (
  locations: LocationDto[],
  treatment?: TreatmentsContainerDto | ServiceContainerDto,
  forcedDoctor?: DoctorDto
) => {
  const [filteredItems, setFilteredItems] = useState<LocationDto[]>([]);
  const [otherItems, setOtherItems] = useState<LocationDto[]>([]);
  let filteredLocations = locations;
  let supportedLocationIds: string[] = [];

  useEffect(() => {
    if (treatment) {
      let allServices: ServiceContainerDto[] = [];
      if (isTreatmentContainer(treatment)) {
        allServices = getServiceContainersFromTreatments(treatment.items);
      }

      supportedLocationIds = allServices.flatMap(
        (service) =>
          service.centerBookingOptions?.map((cbo) => cbo.centerId) || []
      );
      filteredLocations = locations.filter((location) => {
        if (location.excludeFromListings) {
          return allServices.some((service) =>
            location.specializations.includes(service.specializationId)
          );
        }
        return true;
      });

      filteredLocations = filteredLocations.filter((loc) => {
        if (loc.isLocation === false) {
          return supportedLocationIds.includes(loc.id);
        }
        return loc.centers.some((centerId) =>
          supportedLocationIds.includes(centerId)
        );
      });
    }
    if (forcedDoctor && forcedDoctor.name) {
      filteredLocations = filteredLocations.filter(
        (loc) =>
          (loc.isLocation &&
            haveCommonElements(loc.centers, forcedDoctor.centers)) ||
          forcedDoctor.centers.includes(loc.id)
      );
    }

    setFilteredItems(filteredLocations);

    const filterUnavailableLocation = (location: LocationDto): boolean => {
      return (
        !location.excludeFromListings &&
        location.isLocation === false &&
        !supportedLocationIds.includes(location.id) &&
        !filteredLocations.some((fl) => fl.id === location.id)
      );
    };
    const unavailable = locations.filter(filterUnavailableLocation);

    setOtherItems(unavailable);
  }, [treatment, forcedDoctor, locations]);

  return {
    filteredLocations: filteredItems,
    unavailableLocations: otherItems,
  };
};
